import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCamera,FiExternalLink}=FiIcons;

function Footer() {
  const currentYear=new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-brand-bg-dark mt-20">
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* About Section - Full Width */}
        <div className="max-w-4xl mx-auto text-center mb-12">
          <div className="flex items-center justify-center mb-6">
            <SafeIcon icon={FiCamera} className="text-2xl text-brand-primary mr-3" />
            <h3 className="text-lg font-bold text-slate-800">About PÓSEFLIO</h3>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed max-w-3xl mx-auto">
            Professional photography pose reference app designed to help photographers direct their subjects with confidence and create stunning portraits. 
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brand-bg-dark pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <div className="text-slate-600 text-xs">
              © {currentYear}{' '}
              <a href="https://matchadesign.com" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:text-brand-primary-dark transition-colors font-medium">
                Matcha Design
              </a>
              . All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;